

export default function WhatsAppButton() {
    const phoneNumber = '2348067677144';
    const message = 'Hello! I would like to make an enquiry.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
        <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 left-6 z-50 bg-[#25D366] text-white w-14 h-14 rounded-full shadow-lg flex items-center justify-center hover:bg-[#128C7E] transition-all duration-300 hover:scale-110 group"
            aria-label="Chat on WhatsApp"
        >
            <i className="ri-whatsapp-line text-3xl"></i>
            <span className="absolute right-full mr-3 bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                Chat with us
            </span>
        </a>
    );
}
